module.exports = __webpack_public_path__ + "270a1523184496219a0440bec1992f53.png";